import { selectCurrentHotelId } from 'accessors'
import GlobalWarningBar from 'components/ReusableComponents/GlobalWarningBar'
import HotelSetupIcon from 'components/ReusableComponents/Icons/HotelSetup'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

const HotelSetupPendingBar = () => {
  const isHotelSetupCompleted = useSelector(s => s.hotelDetails.isPreOnboardingCompleted)
  const currentPath = useLocation().pathname
  const currentHotelId = useSelector(selectCurrentHotelId)

  if (!currentHotelId) {
    return null
  }

  if (isHotelSetupCompleted) {
    return null
  }

  if (currentPath.includes('hotel-setup')) {
    return null
  }

  return (
    <GlobalWarningBar
      linkTo="/hotel-setup"
      title="Hotel setup is not completed yet."
      description="Please complete the hotel setup to start using the platform. Click on this bar to complete the setup."
      icon={
        <HotelSetupIcon
          styles={{
            fill: '#b8a713',
            width: '30px',
            height: '30px',
            marginRight: '8px',
            marginTop: '-10px'
          }}
        />
      }
    />
  )
}

export default HotelSetupPendingBar
